"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _emotion = require("emotion");
var _reactIntl = require("react-intl");
var _reactComponents = require("@cimpress/react-components");
var _ItemPriceDiagnostic = _interopRequireDefault(require("./ItemPriceDiagnostic"));
var _ItemPriceAdjustment = _interopRequireDefault(require("./ItemPriceAdjustment"));
var _itemDetails = require("../apis/itemDetails");
var _debug = require("../utils/debug");
var _priceutils = require("../utils/priceutils");
var _priceAdjustmentUtils = require("../utils/priceAdjustmentUtils");
var _i18n = require("../utils/i18n");
var _reactI18next = require("react-i18next");
var _pricingResource = require("../lib/pricingResource");
var _pricingResource2 = require("../constants/pricingResource");
var _invoicingStatus = require("../lib/invoicingStatus");
var _InvoicingStatusButton = _interopRequireDefault(require("./common/buttons/InvoicingStatusButton"));
var _InvoicingStatuses = require("../constants/InvoicingStatuses");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Spinner = _reactComponents.shapes.Spinner;
var priceDivClass = (0, _emotion.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 1;\n"])));
var priceNameHeaderClass = (0, _emotion.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 0 0;\n  max-width: 200px;\n"])));
var priceValueClass = (0, _emotion.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1.5;\n  margin-left: 10px;\n  align-content: center;\n  align-items: center;\n"])));
var itemPriceAdjustmentClass = (0, _emotion.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-left: 10px\n"])));
var spinnerClass = (0, _emotion.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-top: 40px;\n  padding-left: 120px;\n"])));
var ItemPriceSummary = /*#__PURE__*/function (_Component) {
  _inherits(ItemPriceSummary, _Component);
  var _super = _createSuper(ItemPriceSummary);
  function ItemPriceSummary(props) {
    var _this;
    _classCallCheck(this, ItemPriceSummary);
    _this = _super.call(this, props);
    _this.state = {
      error: null,
      priceInfo: null,
      manufacturingProductCost: null,
      transferProductPrice: null,
      transferShippingPrice: null,
      loadingPrice: true,
      loadingItem: true,
      loadedPrice: false,
      checkingPermission: true,
      canAdjustPrice: false,
      itemsInvoicingStatus: null,
      loadingInvoicingStatus: _InvoicingStatuses.loadingInvoicing.NOT_LOADING,
      isB2B: props.buyerAccountId !== props.sellerAccountId,
      productConfigurationHref: null
    };
    _this.pasLoader = new _pricingResource.PasLoader();
    _this.invoicingStatus = new _invoicingStatus.InvoicingStatus();
    return _this;
  }
  _createClass(ItemPriceSummary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.getPrices();
      this.getInvoicingStatus();
      var _this$props = this.props,
        itemId = _this$props.itemId,
        accessToken = _this$props.accessToken;
      this.setState({
        loadingItem: true
      }, function () {
        (0, _itemDetails.getItemDetails)(itemId, accessToken).then(function (itemDetails) {
          var globalFulfillerId = itemDetails.globalFulfillerId,
            _links = itemDetails._links;
          _this2.checkUserPermissions(globalFulfillerId);
          _this2.setState({
            loadingItem: false,
            productConfigurationHref: _links.productConfiguration.href
          });
        })["catch"](function () {
          _this2.setState({
            loadingItem: false
          });
        });
      });
      (0, _itemDetails.getItemDetails)(itemId, accessToken).then(function (itemDetails) {
        var globalFulfillerId = itemDetails.globalFulfillerId,
          _links = itemDetails._links;
        _this2.checkUserPermissions(globalFulfillerId);
        _this2.setState({
          productConfigurationHref: _links.productConfiguration.href
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.itemId !== prevProps.itemId) {
        this.componentDidMount();
      }
    }
  }, {
    key: "checkUserPermissions",
    value: function checkUserPermissions(globalFulfillerId) {
      var _this3 = this;
      var _this$props2 = this.props,
        accessToken = _this$props2.accessToken,
        merchantId = _this$props2.merchantId;
      this.setState({
        checkingPermission: true,
        canAdjustPrice: false
      }, function () {
        (0, _priceAdjustmentUtils.checkPriceAdjustmentPermission)(accessToken, globalFulfillerId, merchantId).then(function (canAdjustPrice) {
          _this3.setState({
            checkingPermission: false,
            canAdjustPrice: canAdjustPrice
          });
        })["catch"](function () {
          _this3.setState({
            checkingPermission: false,
            canAdjustPrice: false
          });
        });
      });
    }
  }, {
    key: "getPrices",
    value: function getPrices() {
      var _this4 = this;
      var _this$props3 = this.props,
        itemId = _this$props3.itemId,
        accessToken = _this$props3.accessToken;
      this.setState({
        loadingPrice: true
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this4$pasLoad, customerProductPrice, customerShippingPrice, transferShippingPrice, transferProductPrice, manufacturingProductCost;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this4.pasLoader.getPrices(accessToken, itemId);
              case 3:
                _yield$_this4$pasLoad = _context.sent;
                customerProductPrice = _yield$_this4$pasLoad.customerProductPrice;
                customerShippingPrice = _yield$_this4$pasLoad.customerShippingPrice;
                transferShippingPrice = _yield$_this4$pasLoad.transferShippingPrice;
                transferProductPrice = _yield$_this4$pasLoad.transferProductPrice;
                manufacturingProductCost = _yield$_this4$pasLoad.manufacturingProductCost;
                _this4.setState({
                  loadingPrice: false,
                  loadedPrice: true,
                  customerProductPrice: customerProductPrice,
                  customerShippingPrice: customerShippingPrice,
                  transferShippingPrice: transferShippingPrice,
                  transferProductPrice: transferProductPrice,
                  manufacturingProductCost: manufacturingProductCost
                });
                _context.next = 16;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                (0, _debug.reportError)(_context.t0);
                _this4.setState({
                  loadingPrice: false,
                  loadedPrice: true,
                  error: _context.t0.response
                });
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      })));
    }
  }, {
    key: "getInvoicingStatus",
    value: function getInvoicingStatus() {
      var _this5 = this;
      var _this$props4 = this.props,
        itemId = _this$props4.itemId,
        accessToken = _this$props4.accessToken,
        createdDate = _this$props4.createdDate,
        buyerAccountId = _this$props4.buyerAccountId,
        sellerAccountId = _this$props4.sellerAccountId;
      var isB2B = this.state.isB2B;
      if (isB2B) {
        this.setState({
          loadingInvoicingStatus: _InvoicingStatuses.loadingInvoicing.LOADING
        }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var itemsInvoicingStatus;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this5.invoicingStatus.getInvoicingStatus(accessToken, itemId, createdDate, buyerAccountId, sellerAccountId);
                case 2:
                  itemsInvoicingStatus = _context2.sent;
                  _this5.setState({
                    itemsInvoicingStatus: itemsInvoicingStatus,
                    loadingInvoicingStatus: _InvoicingStatuses.loadingInvoicing.AVAILABLE
                  });
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      } else {
        var itemsInvoicingStatus = {
          link: '',
          status: _InvoicingStatuses.InvoicingStatuses.notInvoiceable,
          tooltip: 'invoicingTooltips:notInvoiceable',
          btnText: 'invoicingStatuses:notInvoiceable'
        };
        this.setState({
          itemsInvoicingStatus: itemsInvoicingStatus,
          loadingInvoicingStatus: _InvoicingStatuses.loadingInvoicing.AVAILABLE
        });
      }
    }
  }, {
    key: "renderItemFormattedNumber",
    value: function renderItemFormattedNumber(priceTitleKey, _ref3) {
      var amount = _ref3.amount,
        currency = _ref3.currency;
      var className = this.props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.cx)(priceDivClass, className)
      }, /*#__PURE__*/_react["default"].createElement("h6", {
        className: (0, _emotion.cx)(priceNameHeaderClass, className)
      }, (0, _i18n.tt)(this.props, priceTitleKey)), /*#__PURE__*/_react["default"].createElement("div", {
        className: priceValueClass
      }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        style: "currency",
        currency: currency,
        value: amount
      })));
    }
  }, {
    key: "renderItemPriceDiagnostic",
    value: function renderItemPriceDiagnostic(priceType, priceTitleKey, price, extra) {
      var _this$props5 = this.props,
        itemId = _this$props5.itemId,
        merchantId = _this$props5.merchantId,
        locale = _this$props5.locale,
        i18n = _this$props5.i18n,
        className = _this$props5.className,
        accessToken = _this$props5.accessToken;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.cx)(priceDivClass, className)
      }, /*#__PURE__*/_react["default"].createElement("h6", {
        className: (0, _emotion.cx)(priceNameHeaderClass, className)
      }, (0, _i18n.tt)(this.props, priceTitleKey, {
        merchant: merchantId
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.cx)(priceValueClass, className)
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ItemPriceDiagnostic["default"], {
        i18n: i18n,
        locale: locale,
        itemId: itemId,
        priceType: priceType,
        useCurrencySymbol: true,
        accessToken: accessToken,
        productConfigurationHref: this.state.productConfigurationHref
      }, price)), extra));
    }
  }, {
    key: "renderInvoicingStatus",
    value: function renderInvoicingStatus(priceTitleKey) {
      var className = this.props.className;
      var _this$state = this.state,
        loadingInvoicingStatus = _this$state.loadingInvoicingStatus,
        itemsInvoicingStatus = _this$state.itemsInvoicingStatus;
      var invoicingBtn = loadingInvoicingStatus === _InvoicingStatuses.loadingInvoicing.LOADING ? /*#__PURE__*/_react["default"].createElement(Spinner, {
        size: "small"
      }) : /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.cx)(priceDivClass, className)
      }, /*#__PURE__*/_react["default"].createElement(_InvoicingStatusButton["default"], {
        invoicingLink: itemsInvoicingStatus.link,
        tooltipText: (0, _i18n.tt)(this.props, itemsInvoicingStatus.tooltip),
        buttonText: (0, _i18n.tt)(this.props, itemsInvoicingStatus.btnText)
      }));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.cx)(priceDivClass, className)
      }, /*#__PURE__*/_react["default"].createElement("h6", {
        className: (0, _emotion.cx)(priceNameHeaderClass, className)
      }, (0, _i18n.tt)(this.props, priceTitleKey)), /*#__PURE__*/_react["default"].createElement("div", {
        className: priceValueClass
      }, invoicingBtn));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        itemId = _this$props6.itemId,
        locale = _this$props6.locale,
        i18n = _this$props6.i18n,
        className = _this$props6.className,
        accessToken = _this$props6.accessToken,
        showManufacturingCost = _this$props6.showManufacturingCost;
      var _this$state2 = this.state,
        error = _this$state2.error,
        loadingPrice = _this$state2.loadingPrice,
        loadedPrice = _this$state2.loadedPrice,
        checkingPermission = _this$state2.checkingPermission,
        canAdjustPrice = _this$state2.canAdjustPrice,
        manufacturingProductCost = _this$state2.manufacturingProductCost,
        transferProductPrice = _this$state2.transferProductPrice,
        transferShippingPrice = _this$state2.transferShippingPrice,
        customerProductPrice = _this$state2.customerProductPrice,
        customerShippingPrice = _this$state2.customerShippingPrice,
        isB2B = _this$state2.isB2B,
        loadingInvoicingStatus = _this$state2.loadingInvoicingStatus,
        loadingItem = _this$state2.loadingItem;
      if (!loadedPrice || loadingPrice || checkingPermission || loadingItem) {
        return /*#__PURE__*/_react["default"].createElement(Spinner, {
          className: spinnerClass,
          size: "medium"
        });
      }
      var noPricing = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, "N/A"));
      var platformProductPrice = (0, _priceutils.isValidPrice)(transferProductPrice) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        currency: transferProductPrice.currency,
        style: "currency",
        value: transferProductPrice.amount
      }) : noPricing;
      var platformShippingPrice = (0, _priceutils.isValidPrice)(transferShippingPrice) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        style: "currency",
        currency: transferShippingPrice.currency,
        value: transferShippingPrice.amount
      }) : null;
      var renderedManufacturingProductCost = (0, _priceutils.isValidPrice)(manufacturingProductCost) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        style: "currency",
        currency: manufacturingProductCost.currency,
        value: manufacturingProductCost.amount
      }) : noPricing;
      var priceAdjustment = canAdjustPrice && (0, _priceutils.isValidPrice)(transferProductPrice) ? /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.cx)(itemPriceAdjustmentClass, className)
      }, /*#__PURE__*/_react["default"].createElement(_ItemPriceAdjustment["default"], {
        i18n: i18n,
        locale: locale,
        itemId: itemId,
        accessToken: accessToken,
        productPrice: transferProductPrice
      })) : null;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
        locale: locale
      }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (error === null || error === void 0 ? void 0 : error.status) === 403 && /*#__PURE__*/_react["default"].createElement("div", null, (0, _i18n.tt)(this.props, 'summary:no_permissions')), (0, _priceutils.isValidPrice)(customerProductPrice) && this.renderItemFormattedNumber('summary:customer_price', customerProductPrice), (0, _priceutils.isValidPrice)(customerShippingPrice) && this.renderItemFormattedNumber('summary:customer_shipping', customerShippingPrice), isB2B && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, this.renderItemPriceDiagnostic(_pricingResource2.priceTypes.productPrice, 'summary:merchant_price', platformProductPrice, priceAdjustment)), platformShippingPrice && /*#__PURE__*/_react["default"].createElement("div", null, this.renderItemPriceDiagnostic(_pricingResource2.priceTypes.shippingPrice, 'summary:merchant_shipping', platformShippingPrice))), showManufacturingCost && this.renderItemPriceDiagnostic(_pricingResource2.priceTypes.manufacturingCostTypeV2, 'summary:manufacturing_product_cost', renderedManufacturingProductCost), loadingInvoicingStatus !== _InvoicingStatuses.loadingInvoicing.NOT_AVAILABLE && this.renderInvoicingStatus('summary:invoicing_status'))));
    }
  }]);
  return ItemPriceSummary;
}(_react.Component);
ItemPriceSummary.propTypes = {
  merchantId: _propTypes["default"].string.isRequired,
  itemId: _propTypes["default"].string.isRequired,
  locale: _propTypes["default"].string,
  accessToken: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  i18n: _propTypes["default"].any,
  // comes from withTranslation
  pasLoader: _propTypes["default"].instanceOf(_pricingResource.PasLoader),
  showManufacturingCost: _propTypes["default"].bool,
  createdDate: _propTypes["default"].any.isRequired,
  buyerAccountId: _propTypes["default"].string.isRequired,
  sellerAccountId: _propTypes["default"].string.isRequired
};
ItemPriceSummary.defaultProps = {
  locale: 'en',
  showManufacturingCost: true
};
var _default = (0, _reactI18next.withTranslation)()(ItemPriceSummary);
exports["default"] = _default;